import React from 'react';

const reviews = [
  {
    name: 'Ahmed Raza',
    location: 'Lahore, Punjab',
    avatar: '👨‍💼',
    rating: 5,
    text: 'Ekdum zabardast experience! Laptop 2 din mein ghar aa gaya. Quality bilkul original aur price bhi bahut reasonable tha. Is se behtar aur koi jagah nahi mili mujhe online.',
    product: 'Gaming Laptop',
    accent: '#00d4ff',
    featured: true,
  },
  {
    name: 'Sana Malik',
    location: 'Karachi, Sindh',
    avatar: '👩‍💻',
    rating: 5,
    text: 'Mujhe darr tha online shopping ka lekin ye experience best tha. Phone bilkul sealed box mein aaya. Highly recommend!',
    product: 'iPhone 15 Pro',
    accent: '#7c3aed',
  },
  {
    name: 'Bilal Hassan',
    location: 'Islamabad',
    avatar: '🧑‍🎓',
    rating: 5,
    text: 'Customer support ne itni jaldi help ki — amazing service. Order tracking feature bhi bahut useful hai.',
    product: 'Wireless Earbuds',
    accent: '#f59e0b',
  },
  {
    name: 'Fatima Noor',
    location: 'Faisalabad',
    avatar: '👩‍🎨',
    rating: 4,
    text: 'Price Amazon se bhi kam tha! Delivery fast thi aur packaging bhi bilkul secure. Next order bhi yahan se.',
    product: 'Smart Watch',
    accent: '#22c55e',
  },
];

const Stars = ({ count, size = 13 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <svg key={i} width={size} height={size} viewBox="0 0 24 24" fill={i < count ? '#fbbf24' : '#2a3547'} stroke="none">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ))}
  </div>
);

const QuoteIcon = ({ color }) => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill={color} opacity="0.25">
    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/>
  </svg>
);

const Testimonials = () => {
  const featured = reviews[0];
  const rest = reviews.slice(1);

  return (
    <section className="py-[90px] px-[8%] border-t border-white/[0.05]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-[rgba(0,212,255,0.1)] text-[#00d4ff] border border-[rgba(0,212,255,0.25)] px-4 py-[5px] rounded-full text-xs font-bold tracking-[2px] uppercase mb-4">
            ⭐ Customer Reviews
          </span>
          <h2 className="text-[44px] font-black text-white -tracking-[1px] max-[700px]:text-[32px]">
            What Our <span className="shimmer-text">Customers Say</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <Stars count={5} size={16} />
            <span className="text-white font-bold text-lg">4.9</span>
            <span className="text-[#4a5568] text-sm">· Based on 12,400+ reviews</span>
          </div>
        </div>

        {/* Featured testimonial — full width banner */}
        <div
          className="relative rounded-3xl overflow-hidden p-8 md:p-12 mb-6 border border-[rgba(0,212,255,0.15)]"
          style={{ background: 'linear-gradient(135deg, #0d1a2d 0%, #0a1020 100%)' }}
        >
          {/* Background glow */}
          <div className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full blur-[80px] pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.12) 0%, transparent 70%)' }} />

          <div className="relative z-10 flex items-start gap-8 flex-wrap max-[700px]:gap-5">
            <QuoteIcon color="#00d4ff" />

            <div className="flex-1 min-w-[200px]">
              <p className="text-[#c9d4e0] text-[18px] md:text-[20px] leading-[1.75] font-medium mb-7 max-[700px]:text-base">
                "{featured.text}"
              </p>
              <div className="flex items-center gap-5 flex-wrap">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl border border-[rgba(0,212,255,0.3)]" style={{ background: 'rgba(0,212,255,0.1)' }}>
                    {featured.avatar}
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm leading-none mb-1">{featured.name}</p>
                    <p className="text-[#6b7a8d] text-xs">{featured.location}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Stars count={featured.rating} size={15} />
                  <span className="text-[#fbbf24] text-xs font-bold">{featured.rating}.0</span>
                </div>
                <div className="inline-block px-3 py-1 rounded-full text-[10px] font-extrabold tracking-[1px] uppercase border" style={{ color: featured.accent, borderColor: `${featured.accent}44`, background: `${featured.accent}10` }}>
                  Verified: {featured.product}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 3 smaller review cards */}
        <div className="grid grid-cols-3 gap-5 max-[900px]:grid-cols-1">
          {rest.map((r, i) => (
            <div
              key={i}
              className="group flex flex-col gap-4 p-6 rounded-2xl border border-white/[0.07] transition-all duration-300 hover:border-white/[0.18] hover:-translate-y-1.5"
              style={{ background: `linear-gradient(135deg, ${r.accent}08 0%, rgba(13,21,38,0.8) 100%)` }}
            >
              <div className="flex items-start justify-between gap-3">
                <QuoteIcon color={r.accent} />
                <Stars count={r.rating} />
              </div>
              <p className="text-[#aab4c4] text-[13.5px] leading-[1.75] flex-1">"{r.text}"</p>
              <div className="flex items-center gap-3 pt-3 border-t border-white/[0.06]">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0 border" style={{ background: `${r.accent}15`, borderColor: `${r.accent}30` }}>
                  {r.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white text-sm font-bold leading-none mb-0.5 truncate">{r.name}</p>
                  <p className="text-[#4a5568] text-xs">{r.location}</p>
                </div>
                <div className="flex-shrink-0 px-2.5 py-1 rounded-full text-[9px] font-extrabold tracking-[1px] uppercase border" style={{ color: r.accent, borderColor: `${r.accent}40`, background: `${r.accent}10` }}>
                  {r.product}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
